import { render, staticRenderFns } from "./InstructionsForm.vue?vue&type=template&id=a5013d1c&scoped=true"
import script from "./InstructionsForm.vue?vue&type=script&lang=js"
export * from "./InstructionsForm.vue?vue&type=script&lang=js"
import style0 from "./InstructionsForm.vue?vue&type=style&index=0&id=a5013d1c&prod&scoped=true&lang=css"
import style1 from "./InstructionsForm.vue?vue&type=style&index=1&id=a5013d1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5013d1c",
  null
  
)

export default component.exports